import gong from './gong/gong.wav';
import doubleGong from './gong/double-gong.wav';
import bellRingtone4 from './gong/bell-ringtone-4.wav';
import friendlyRingtone from './gong/friendly-ringtone.wav';
import gongNew from './gong/gong-new.wav';
import xylophoneJingle06 from './gong/xylophone-jingle-06.wav';

import axios from 'axios';

import {name} from '../package.json';

import arrow from './arrows/arrows';
import template from './app-root.html';
import themes from './themes/themes';
import NewBigTheme from './themes/new-big-theme';
import NewNormalTheme from './themes/new-normal-theme';
import NewCustomTheme from './themes/new-custom-theme';
import OldTheme from './themes/old-theme';
import {SoundSource} from './audio/soundSource';
import {clearCacheResponse} from './cache-utils';
import {getBlobFromUrl} from './blob-utils';

export default {
	name: 'AppRoot',
	template,
	components: {NewBigTheme, NewNormalTheme, OldTheme, NewCustomTheme},
	data () {
		return {
			themes,
			currentTheme: null,
			data: [],
			lastModified: {},
			fontFamily: 'Open Sans',
			backgroundUrl: null,
			customRowClasses: [],
			popupCall: {
				enabled: false,
				style: {}
			}
		};
	},
	created () {
		this.httpClient = axios.create({
			timeout: 1000,
			headers: {
				'Cache-Control': 'max-age=0',
				'Accept': 'application/json, text/javascript, */*; q=0.01'
			}
		});
		window.playGong = () => {
			this.canPlay = true;
			this.playGong();
		};
		const {Sentry, config} = this.$root;

		this.ddd = {
			1: '{"call":[{"d":"E269 2","a":"d","b":"1","g":"1"},{"d":"A268 22","a":"d"},{"d":"B150 1","a":"l"},{"d":"267 2","a":"d"},{"d":"266 2","a":"d"},{"d":"149 1","a":"l"}]}',
			2: '{"call":[{"d":"L260 2","a":"d"},{"d":"M118 15","a":"u"},{"d":"N50 1","a":"l"},{"d":"O7 23","a":"l"},{"d":"P6 22","a":"r"},{"d":"Q9 20","a":"l","b":"1","g":"1"}]}',
			3: '{"call":[{"d":"M269 2","a":"d"},{"d":"N268 22","a":"d"},{"d":"O150 1","a":"l"},{"d":"P67 2","a":"d","g":"1","b":"1"},{"d":"Q66 2","a":"d"},{"d":"R49 1","a":"l"}]}',
			4: '{"call":[{"d":"G4 Ambulance+1"},{"d":"H50 Recepce+22","a":"l"},{"d":"I53 Dve%C5%99e+1"},{"d":"J7 Dve%C5%99e+2","a":"l"},{"d":"K655 Recepce+22","a":"r","b":"1","g":"1"},{"d":"L933 Ambulance+1"}]}',
			5: '{"call":[{"d":"X260 2","a":"d"},{"d":"Y118 15","a":"u"},{"d":"Z50 1","a":"l","b":"1","g":"1"},{"d":"A7 23","a":"l"},{"d":"B6 22","a":"r"},{"d":"49 20","a":"l"}]}'
		};

		this.currentTheme = config.theme.name;
		this.fontFamily = config.theme.fontFamily || 'Open Sans';
		this.backgroundUrl = config.theme.backgroundUrl || null;
		this.customRowClasses = config.theme.customRowClasses || '';
		this.arrowStyle = config.theme.arrowStyle;
		this.popupCall = config.theme.popupCall;

		(async () => {
			if (!('caches' in window)) {
				return;
			}
			let resources = [{
				url: config.theme.backgroundUrl,
				callback: (blobUrl) => (this.backgroundUrl = blobUrl)
			}, {
				url: config.theme.popupCall.backgroundUrl,
				callback: (blobUrl) => (this.popupCall = {...config.theme.popupCall, backgroundUrl: blobUrl})
			}];

			try {
				await clearCacheResponse(name, resources.map(({url}) => url));
			// eslint-disable-next-line no-empty
			} catch (_) {}

			resources = resources.filter(({url}) => Boolean(url));
			await Promise.all(
				resources.map(({url, callback}) =>
					getBlobFromUrl(name, url)
						.then(callback)
						.catch(() => console.error('failed to cache background image', url)))
			);
		})();

		this.canPlay = true;
		new Promise((resolve) => {
			const AudioContext = window.AudioContext || window.webkitAudioContext;
			const context = new AudioContext();
			const gainNode = context.createGain();
			gainNode.gain.value = config.volume / 100;
			gainNode.connect(context.destination);

			let sound;
			switch (config.playSound.toLowerCase()) {
			case 'bell-ringtone-4':
				sound = bellRingtone4;
				break;
			case 'friendly-ringtone':
				sound = friendlyRingtone;
				break;
			case 'gong-new':
				sound = gongNew;
				break;
			case 'xylophone-jingle-06':
				sound = xylophoneJingle06;
				break;
			case 'double-gong':
				sound = doubleGong;
				break;
				// Nastavení výchozích hodnot pro zvukovou signalizaci je gong.
				// Nové možnosti přidávat nad tento case.
			case 'gong':
			default:
				sound = gong;
			}
			// Příprava audio souboru pro přehrávání.
			this.source = new SoundSource(context, gainNode, sound, (duration) => {
				this.duration = duration;
				resolve();
			});
		})
		// Pokud by selhalo načtení audio souboru, odešle se hlášení na server.
		// Nedojde k zaseknutí celého widgetu.
		.catch((error) => Sentry.captureException(error))
		// Zahájení nekonečné smyčky aktualizace.
		.then(() => this.loop())
		.catch((error) => Sentry.captureException(error));

		this.playGong = this.playGong.bind(this);
	},
	destroyed () {
		[
			this.backgroundUrl,
			this.popupCall.backgroundUrl
		].filter((url) => Boolean(url)).forEach((url) => URL.revokeObjectURL(url));
	},
	methods: {
		getAllData (server, identifications) {
			return new Promise((resolve) => resolve(
				// Počká se na všechny dotazy na všechny fronty.
				// Data z front se následně namapují do objektu
				// Může nastat situace, kdy jedna fronta vrátí 304 a druhá 200
				Promise.allSettled(identifications.map((id, idx) => this.getData(server, id, idx)))
				.then((responses) => responses.reduce((acc, item, idx) => {
					// Vytvoří se objekt, jehož properties budou
					// identifikátory front vyvolávacího systému
					// chyby typu 304, se odfiltruji
					if (item.status === 'fulfilled') {
						acc[identifications[idx]] = {data: item.value};
						return acc;
					}
					// TODO tady lze odchytavat chyby z Promise item.status === 'rejected' ==> item.reason
					return acc;
				}, {}))
			));
		},
		getData (server, id, idx) {
			const headers = {};
			if (this.lastModified[id]) {
				headers['If-Modified-Since'] = this.lastModified[id];
			}
			// Získá data z jedné fronty a převede je do vnitřního formátu
			return new Promise((resolve) => resolve(
				Promise.resolve(JSON.parse(this.ddd[idx]))
				.then((res) => res.call.map((call) => ({
					id: this.$root.randomizer.createString(3),
					patient: call.d.substr(0, call.d.indexOf(' ')) || '---',
					door: this.decodeWithPlus(call.d.substr(call.d.indexOf(' ') + 1)) || '--',
					arrow: arrow.get(call.a, this.arrowStyle),
					blink: Boolean(call.b),
					gong: Boolean(call.g)
				})))
			));
		},
		decodeWithPlus (str) {
			return decodeURIComponent(str.replace('+', '%20'));
		},
		loop () {
			// V nekonečné smyčce se aktualizuje obsah widgetu.
			return new Promise((resolve) => resolve(
				this.refresh()
				.catch((error) => this.$root.Sentry.captureException(error))
				.finally(() => {
					setTimeout(this.loop, this.$root.config.refreshInterval * 1000);
				})
			));
		},
		playGong () {
			this.$root.Sentry.addBreadcrumb({message: 'Playing the gong.'});
			if (this.canPlay) {
				this.canPlay = false;
				this.source.start();
				setTimeout(() => {
					this.canPlay = true;
					// Dovolím hrát až po uplynutí délky zvuku.
					// Přidání ochranné 1s sekundy pro sichr (samo LG píše o něčem takovém na webu).
				}, 1000 * (Math.ceil(this.duration) + 1));
			}
		},
		refresh () {
			return new Promise((resolve) => {
				const {Sentry, config} = this.$root;
				Sentry.addBreadcrumb({message: 'Refreshing the data.'});
				const {queues} = config;
				return resolve(
					// Kontaktování serveru se všemi identifikátory front
					// Vyfiltrování identifikátorů ze všech front do pole identifikátorů
					this.getAllData(config.serverUrl, Object.keys(queues))
					.then((data) => {
						// Pokud jsou již data, a nová nepřšla tak nic nedělej
						if (this.data.length > 0 && Object.entries(data).length === 0) {
							return;
						}
						const res = config.guid.map((id) => {
							let d = [];
							// Pokud nejsou pro dané id nová data,
							// tak načtu ty staré z this.data
							if (!data[id] || !data[id].data) {
								const currentData = this.data.filter((q) => q.id === id);
								// Pokud existuji data pro aktualni frontu, protoze ze severu nic neprislo
								if (currentData.length > 0) {
									d = currentData[0].data;
								}
							} else {
								const limit = queues[id].count;
								// Pouziti novych dat z odpovedi
								d = data[id].data.slice(0, limit);
							}
							return {...queues[id], data: d};
						});
						// Nalezeni alespon jednoho gong === true, pokud zadny neni nalezne, tak je vysledek false
						const isGong = res.reduce((acc, cur) => acc || cur.data.filter((row) => row.gong).length > 0, false);
						if (isGong) {
							// Přehrání gongu nezablokuje widget, ale zaloguje se na Sentry.
							try {
								this.playGong();
							} catch (error) {
								Sentry.captureException(error);
							}
						}
						this.data = res;
					})
				);
			});
		}
	}
};
